'use client';

import React, {
  useEffect, useCallback, useMemo,
} from 'react';
import { useAnalytics } from 'reaxl-analytics';
import { default as generateDataLayerObject } from '../analytics/useDataLayer.js';
import useDataIsland from '../analytics/useDataIsland.js';
import dynamic from 'next/dynamic';
import { getBrowserZipcode } from '../utilities/akamaiFunctions.js';

// Simple dynamic imports without blocking
const BuyerLandingHero = dynamic(() => import('../components/LandingPage/BuyerLandingHero.tsx'), {
  ssr: true,
});

const SellYourCarSection = dynamic(() => import('../components/LandingPage/SellYourCarSection.tsx'), {
  ssr: true,
});

const ShoppingStepsSection = dynamic(() => import('../components/LandingPage/ShoppingStepsSection.tsx'), {
  ssr: true,
});

const BuildingTrustSection = dynamic(() => import('../components/LandingPage/BuildingTrustSection.tsx'), {
  ssr: true,
});

const RecentListings = dynamic(() => import('../components/LandingPage/RecentListings.js'), {
  ssr: false, // Client-side only for performance
});

const SellByTypesSection = dynamic(() => import('../components/LandingPage/SellByTypesSection.tsx'), {
  ssr: true,
});

const ShopPrivateSellerCarsByPriceSection = dynamic(() => import('../components/LandingPage/ShopPrivateSellerCarsByPriceSection.tsx'), {
  ssr: true,
});

export default function LandingPageContainer() {
  const { sendPage } = useAnalytics();

  const dataIsland = useDataIsland();

  // Generated by GitHub Copilot
  // Memoize zipCode to prevent re-renders from getBrowserZipcode calls
  const zipCode = useMemo(() => getBrowserZipcode(), []);

  const sendInitialPage = useCallback(async () => {
    const dataLayer = await generateDataLayerObject();
    sendPage({
      data: {
        page: 'syc_psx_buy',
        googlePageName: 'syc_psx_buy',
        zipCode,
      },
      dataLayer,
      isInitialLoad: true,
      dataIsland,
      state: dataLayer?.state,
      userDuck: dataLayer?.userDuck,
    });
  }, [dataIsland, sendPage, zipCode]);

  useEffect(() => {
    sendInitialPage();
  }, [sendInitialPage]);

  return (
    <>
      {/* Hero section - highest priority for LCP */}
      <BuyerLandingHero />

      {/* Above-the-fold content */}
      <ShoppingStepsSection />

      <SellByTypesSection />

      {/* Below-the-fold content */}
      <BuildingTrustSection />

      {/* Heavy data component */}
      <RecentListings />

      <SellYourCarSection />

      <ShopPrivateSellerCarsByPriceSection />
    </>
  );
}
